import client from "@/api/client"
import {
  industriesResponseSchema,
  industrySingleResponseSchema,
} from "@/api/schemas/business"

export type Industry = {
  _id?: string
  name?: string
  createdAt?: string
}

export type GetIndustriesParams = {
  page?: number
  pageSize?: number
  name?: string
}

export const getIndustries = async (params?: GetIndustriesParams) => {
  const response = await client.get("/api/v1/business/industries", {
    params: params?.page != null ? params : undefined,
  })
  return industriesResponseSchema.parse(response.data)
}

export const createIndustry = async (name: string) => {
  const response = await client.post("/api/v1/business/industries", { name })
  return industrySingleResponseSchema.parse(response.data)
}

export const updateIndustry = async (id: string, name: string) => {
  const response = await client.patch(`/api/v1/business/industries/${id}`, {
    name,
  })
  return industrySingleResponseSchema.parse(response.data)
}
